// extracted by mini-css-extract-plugin
export var actions = "_44-0";
export var actionsContainer = "_44-6";
export var border = "_44-1";
export var childFullHeight = "_44-d";
export var collapse = "_44-2";
export var content = "_44-8";
export var contentChild = "_44-c";
export var fullscreen = "_44-a";
export var headerContainer = "_44-3";
export var headerRow = "_44-5";
export var hidePadding = "_44-9";
export var noScrollX = "_44-e";
export var noScrollY = "_44-f";
export var optOutTopPadding = "_44-b";
export var pagePadding = "_44-7";
export var profile = "_44-g";
export var profileContainer = "_44-h";
export var profileImage = "_44-i";
export var profileMain = "_44-j";
export var profileSubtitle = "_44-l";
export var profileTitle = "_44-k";
export var tabsWrapper = "_44-4";
export var title = "_44-m";